import { type FC } from "react";
import { BadgeHelp, Clock, CircleAlert, CheckCircle2, Info } from "lucide-react";

import type { SidebarPanel } from "@/shared/types/estateEssentials";

interface InlineFormSidebarProps {
  panels: SidebarPanel[];
  deceasedFirstName: string;
}

const PANEL_ICONS: Record<string, FC<{ className?: string }>> = {
  "What happens next": BadgeHelp,
  "Processing time": Clock,
  "What this doesn't do": CircleAlert,
  "Good to know": Info,
  "$6 filing fee": CheckCircle2,
};

const PANEL_ICON_CLASS: Record<string, string> = {
  "$6 filing fee": "size-4 text-green-700",
};

export const InlineFormSidebar: FC<InlineFormSidebarProps> = ({ panels, deceasedFirstName }) => {
  return (
    <div className="rounded-lg border border-primary bg-white p-6 space-y-6">
      {panels.map((panel) => {
        const Icon = PANEL_ICONS[panel.title];
        const iconClass = PANEL_ICON_CLASS[panel.title] ?? "size-4 text-secondary";
        const content = panel.content.replace(
          /\{\{\s*deceased_first_name\s*\}\}/g,
          deceasedFirstName || "your loved one",
        );

        return (
          <div key={panel.title} className="space-y-2">
            <div className="flex items-center gap-2">
              {Icon && <Icon className={iconClass} />}
              <p className="text-sm font-semibold">{panel.title}</p>
            </div>
            <p className="text-sm text-secondary leading-relaxed">{content}</p>
          </div>
        );
      })}
    </div>
  );
};
